import * as filter from "lodash/filter";

export const autoTickerRowTranslations =
{
    "he": {
        "Now": "עכשיו",
        "News Flash": "מבזקים",
        "ExtendedView": "תצוגה מורחבת",
        "StandardView": "תצוגה רגילה",
        "ShareByMail": "שיתוף במייל",
        "ShareByTwitter": "שיתוף בטוויטר",
        "ShareByFacebook": "שיתוף בפייסבוק",
        "ShareByWhatsApp": "שיתוף בואטסאפ",
        "ToAllFlashes": "לכל המבזקים",
        "ToFullFlashesPage": "לעמוד המבזקים המלא",
        "Share": "שיתוף"
    },
    "en": {
        "Now": "now",
        "News Flash": "News Flash",
        "ExtendedView": "Extended view",
        "StandardView": "Standard view",
        "ShareByMail": "Share by Mail",
        "ShareByTwitter": "Share by Twitter",
        "ShareByFacebook": "Share by Facebook",
        "ShareByWhatsApp": "Share by WhatsApp",
        "ToAllFlashes": "To all flashes",
        "ToFullFlashesPage": "To full flashes page",
        "Share": "Share"
    },
    "ru": {
        "Now": "в настоящее время",
        "News Flash": "Новости",
        "ExtendedView": "Расширенный вид",
        "StandardView": "Стандартный вид",
        "ShareByMail": "Поделиться по почте",
        "ShareByTwitter": "Поделиться в Твиттере",
        "ShareByFacebook": "Поделиться через Facebook",
        "ShareByWhatsApp": "Поделиться по WhatsApp",
        "ToAllFlashes": "Все новости",
        "ToFullFlashesPage": "На страницу всех новостей",
        "Share": "Поделиться"
    },
}

const monthsTranslations: { [key: string]: string[] } = {
    "he": ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
    "en": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    "ru": ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"],
}

export const getTranslation = (lang: string, text: string) => {
    var obj = filter(autoTickerRowTranslations, function (v, k) {
        return k === lang;
    });
    var content = filter(obj[0], function (v, k) {
        return k === text;
    })

    return content[0]
}


export const getMonthTranslation = (lang: string, monthNumber: number) => {
    if (monthNumber < 0 || monthNumber > 11) {
        return "";
    }

    return monthsTranslations[lang][monthNumber];
}
